import type { MetricDelta } from "@fox1ck-org/ui";
import type { StatsRow } from "@gen/tracker/v1/reporting_pb";

import { derive, type Bag } from "@/lib/campaigns-table";
import { formatChange, formatPp, relativeChange } from "@/lib/format";
import { statsRowToNumbers, type ReportingSchema } from "@/lib/services/reporting-schema-service";

/**
 * The metrics a lander screen reads, every one the reporting registry's
 * (board «Словарь метрик»): «Визиты» are the clicks routed to the page, «Люди»
 * those that were a person, «Пошли дальше» the clicks on its buttons, LP CTR
 * those over its shows, «Конверсии» its leads, CR leads over people.
 */
export const LANDER_METRICS = ["visits", "clicks", "bots", "lander_shows", "cta_clicks", "lp_ctr", "leads", "cr", "conversions", "approve_rate", "revenue", "lander_epc", "cost", "profit"];

/** A StatsRow as the screen's bag, derived like the list derives it. Pure. */
export function bagOf(row: StatsRow | undefined, schema: ReportingSchema | undefined): Bag | undefined {
  if (!row) return undefined;
  const base = statsRowToNumbers(row);
  return schema ? derive(schema.metrics, base) : base;
}

/** The change of a count or money: «+12%». Absent when there is nothing to compare. Pure. */
export function countDelta(cur: number | undefined, prev: number | undefined, good: "up" | "down" = "up"): MetricDelta | undefined {
  if (cur === undefined || prev === undefined || relativeChange(cur, prev) === undefined) return undefined;
  return { value: formatChange(cur, prev), direction: cur > prev ? "up" : cur < prev ? "down" : "flat", good };
}

/** The change of a rate, in percentage points: «−1 п.п.». Pure. */
export function rateDelta(cur: number | undefined, prev: number | undefined): MetricDelta | undefined {
  if (cur === undefined || prev === undefined) return undefined;
  return { value: formatPp(cur - prev), direction: cur > prev ? "up" : cur < prev ? "down" : "flat", good: "up" };
}
